import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { BuilderContextProvidersRegistry } from './builderContextProvidersRegistry'
import { BuilderContextProvidersLoader } from './builderContextProvidersLoader'
import { BuilderContextProvidersPageWillMountHandler } from './builderContextProvidersPageWillMountHandler'
import { ContextProviderLoaderSymbol, ContextProviderRegistrySymbol } from './symbols'
import { LifeCycle, ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import {
	ContextProviderService,
	ContextBindingService,
	NoopContextBindingService,
	NoopContextProviderService,
} from './services'
import { ComponentWrapperSymbol } from '@wix/thunderbolt-components-loader'
import { ContextProviderWrapper } from './ContextProviderWrapper'
import { ContextBindingWrapper } from './ContextBindingWrapper'

export const bindCommonSite: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(NoopContextProviderService)
	bind(ServiceProviderSymbol).to(NoopContextBindingService)
	bind(ContextProviderRegistrySymbol).to(BuilderContextProvidersRegistry)
	bind(ComponentWrapperSymbol).to(ContextProviderWrapper)
	bind(ComponentWrapperSymbol).to(ContextBindingWrapper)
}

export const site: ContainerModuleLoader = (bind) => {
	bindCommonSite(bind)
	bind(ContextProviderLoaderSymbol).to(BuilderContextProvidersLoader)
}

export const page: ContainerModuleLoader = (bind) => {
	bind(LifeCycle.PageWillMountHandler).to(BuilderContextProvidersPageWillMountHandler)
	bind(ServiceProviderSymbol).to(ContextProviderService)
	bind(ServiceProviderSymbol).to(ContextBindingService)
}
